/**
 * Pipe that validates if Facebook is currently
 * enabled for a selected location in a specific 
 * environment. 
 */
import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments/environment';
import { LocationsFacadeService } from '@services/locations/locations-facade.service';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'isFacebookEnabled'
})
export class IsFacebookEnabledPipe implements PipeTransform, OnDestroy {

  _subs: Subscription = new Subscription()
  private facebookEnabled = false;

  constructor(private locationFacadeService: LocationsFacadeService) {
    this._subs.add(
      this.locationFacadeService.getCurrentLocation$().subscribe(location => {
        this.facebookEnabled = environment.facebookEnabled && (
          environment.facebook_whitelist.length == 0
            || environment.facebook_whitelist.some(item => item == location.id)
          )
      })
    );
  }

  /**
   * Based on a previous condition this function determines if
   * the selected location has facebook enabled within the specific
   * environment depending on facebookEnabled and facebook_whitelist 
   * properties set on either environment.ts or environment.prod.ts.
   * 
   * This pipe will determine if certain HTML components
   * will be shown on the UI for the selected location.
   * 
   * @param condition Contains a boolean value set by a previous
   * set of conditions applied before the pipe.
   */
  transform(condition: boolean | null): boolean {
    return this.facebookEnabled && condition;
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe()
  }

}
